import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import capitalize from 'lodash-es/capitalize';
import grey from 'sushiweb/tokens/color/grey';
import { P } from 'sushiweb/Typography/Text';
import Check from 'sushiweb/Icons/all/Check';
import white from 'sushiweb/tokens/color/white';
import H6 from 'sushiweb/Typography/Heading/H6';
import Cross from 'sushiweb/Icons/all/Cross';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import {
  CheckedBox,
  StyledChevronDown,
  StyledChevronUp,
  UncheckedBox,
} from '../../../WalletPrograms/styles';
import {
  ClearCrossWrapper,
  CustomStatusDropdown,
  StatusCheckboxWrapper,
  StatusDropdownContainer,
  StatusDropdownOptions,
  StatusFilterWrapper,
} from './styles';
import { statusLabels } from '../constants';
import { includesOption } from '../../../../helpers';

const StatusFilter = ({
  isDisabled,
  clearFilters,
  currentFilters,
  handleSelect,
  options,
}) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    clearFilters();
    setOpen(false);
  };

  const renderOptions = () => {
    return options.map(option => (
      <StatusCheckboxWrapper
        key={option.value}
        onClick={() => {
          if (!option.disabled) handleSelect(option);
        }}
        disabled={option.disabled}
      >
        {includesOption(currentFilters, option) ? (
          <CheckedBox>
            <Check size={15} color={white} />
          </CheckedBox>
        ) : (
          <UncheckedBox disabled={option.disabled} />
        )}
        <P style={{ fontSize: '13px' }}>
          {capitalize(statusLabels[option.label])}
        </P>
      </StatusCheckboxWrapper>
    ));
  };

  return (
    <OnClickOutside
      removeHandler={!open}
      handleClickOutside={() => setOpen(false)}
    >
      <StatusFilterWrapper>
        <StatusDropdownContainer>
          <CustomStatusDropdown
            disabled={isDisabled}
            open={!isDisabled ? open : false}
            onClick={() => {
              if (!isDisabled) setOpen(!open);
            }}
          >
            {currentFilters.length === 0 ? (
              <H6 id='unselected'>Filter by status</H6>
            ) : (
              <>
                <ClearCrossWrapper onClick={handleClose}>
                  <Cross />
                </ClearCrossWrapper>
                <P id='selected'>
                  {currentFilters.length} of {options.length} selected
                </P>
              </>
            )}
            {open ? (
              <StyledChevronUp size={24} color={grey.z500} />
            ) : (
              <StyledChevronDown size={24} color={grey.z500} />
            )}
          </CustomStatusDropdown>
          {open && (
            <StatusDropdownOptions>
              <StatusDropdownOptions.Groups>
                {renderOptions()}
              </StatusDropdownOptions.Groups>
              {/* <StatusDropdownOptions.ApplyFilter>
                <Button
                  size='small'
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Apply
                </Button>
              </StatusDropdownOptions.ApplyFilter> */}
            </StatusDropdownOptions>
          )}
        </StatusDropdownContainer>
      </StatusFilterWrapper>
    </OnClickOutside>
  );
};
StatusFilter.propTypes = {
  isDisabled: PropTypes.bool,
  clearFilters: PropTypes.func,
  currentFilters: PropTypes.array,
  options: PropTypes.array,
  handleSelect: PropTypes.func,
};

StatusFilter.defaultProps = {
  isDisabled: false,
  clearFilters: _noop,
  currentFilters: [],
  options: [],
  handleSelect: _noop,
};
export default StatusFilter;
